import { unitDefault, unitTypes } from "@/settings/unitTypes";
export const GearBox = {
  id: "30",
  name: "Caja de Engranaje",
  mainClass: "Rotativos",
  subtype: "",
  variables: [],
  operationalValues: [
    {
      value: 0,
      type: unitTypes.angularSpeed,
      unit: unitDefault.angularSpeed.metric,
      code: "gearBoxInputSpeed"
    },
    {
      value: 0,
      type: unitTypes.angularSpeed,
      unit: unitDefault.angularSpeed.metric,
      code: "gearBoxOutputSpeed"
    },
    {
      value: "Engine",
      type: "unique",
      unit: "",
      code: "gearBoxDriver"
    },
    {
      value: "Generator",
      type: "unique",
      unit: "",
      code: "gearBoxDriven"
    },
    {
      value: 0,
      type: unitTypes.power,
      unit: unitDefault.power.metric,
      code: "gearBoxPower"
    },
    {
      value: 1,
      type: "unique",
      unit: "",
      code: "gearServiceFactor"
    }
  ]
};
